import {isLocal} from '@Libraries/environment-library';

let devAssertionsEnabled: boolean | null = null;

/**
 * Dev-mode invariant assertions for the poster domain model (history snapshot sync,
 * copyVals clobber detection, corrupted-background encodings). They report via
 * console.error so violations fail any test run with a strict console policy and are
 * loud during local development, while production stays silent and pays no diff cost.
 *
 * `null` (default) auto-detects: enabled on local dev, disabled elsewhere. Tests should
 * call setDevAssertionsEnabled(true) explicitly rather than rely on detection.
 */
export const setDevAssertionsEnabled = (enabled: boolean | null): void => {
  devAssertionsEnabled = enabled;
};

export const areDevAssertionsEnabled = (): boolean => {
  if (devAssertionsEnabled !== null) {
    return devAssertionsEnabled;
  }
  try {
    return isLocal();
  } catch {
    return false;
  }
};
